class Response {
    constructor(status, message = '', data = {}){
        this.statusCode = status;
        this.message = message;
        this.data = data;
    }

    /** Returns new Response object from given HttpResponse object. */
    static getResponse(httpResponse) {
        return new Response(httpResponse.status, httpResponse.data.message, httpResponse.data.data);
    }
} 

export default Response;